import { Box } from "@mui/material";

const SUMMARY_TILE_SX = {
  flex: 1,
  border: "1px solid #E8EBF0",
  borderRadius: "10px",
  padding: "14px 16px",
  backgroundColor: "#FAFAFC",
};

function formatDaysValue(value) {
  const days = typeof value === "number" ? value : parseFloat(value);
  if (!Number.isFinite(days)) return "-";
  const formatted = Number.isInteger(days) ? days : days.toFixed(1);
  return `${formatted} days`;
}

function ClaimApprovalTurnaroundSummaryTiles({ summary }) {
  if (!summary) return null;
  const tiles = [
    { value: formatDaysValue(summary?.avg_approval_days), label: "Avg approval time" },
    { value: Number.isFinite(summary?.claims_submitted) ? summary.claims_submitted : "-", label: "Claims submitted" },
    { value: Number.isFinite(summary?.claims_pending) ? summary.claims_pending : "-", label: "Claims pending" },
  ];
  return (
    <Box sx={{ display: "flex", gap: 1.5, mb: 1.5 }}>
      {tiles.map((tile) => (
        <Box key={tile.label} sx={SUMMARY_TILE_SX}>
          <Box sx={{ fontSize: 22, fontWeight: 700, color: "#1B2A4A", lineHeight: 1.2 }}>{tile.value}</Box>
          <Box sx={{ fontSize: 13, color: "#8E97A8", mt: 0.5 }}>{tile.label}</Box>
        </Box>
      ))}
    </Box>
  );
}

export default ClaimApprovalTurnaroundSummaryTiles;
